module.exports = require('./$.global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/$.html.js
// module id = 602
// module chunks = 174 178 179 193 194